import { render, staticRenderFns } from "./LeaveSummaries.vue?vue&type=template&id=193cca56&"
import script from "./LeaveSummaries.vue?vue&type=script&lang=js&"
export * from "./LeaveSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports